import {
  Badge,
  Group,
  HoverCard,
  LoadingOverlay,
  NumberFormatter,
  Paper,
  Stack,
  Text,
} from "@mantine/core";
import { IconArrowDown, IconArrowUp } from "@tabler/icons-react";
import { useMemo } from "react";

const TotalBilling = ({ stats, defaultStats, loading }) => {
  const result = useMemo(() => {
    const previous = stats.stats_previous_range?.total_sum_billed;
    const actual = stats.stats_current_range?.total_sum_billed;
    const newUsers = actual - previous;
    const rate = (newUsers / actual) * 100;

    return {
      newUsers: newUsers || 0,
      rate: rate ? rate.toFixed(1) : 0,
    };
  }, [stats]);

  return (
    <HoverCard position="right">
      <HoverCard.Target>
        <Paper
          component={Stack}
          gap={0}
          p={"lg"}
          px={"xl"}
          radius={"md"}
          bg={"#fff"}
          w={"100%"}
          pos={"relative"}
        >
          <LoadingOverlay visible={loading} />
          <Text size="xl">Total CA généré</Text>

          <Group>
            <Text fz={30} fw={600}>
              <NumberFormatter
                value={Math.floor(
                  defaultStats.stats_current_range.total_sum_billed
                )}
                suffix="€"
              />{" "}
              <Text
                span
                fz={24}
                fw={600}
                c={result.newUsers > 0 ? "green.8" : "red.8"}
              >
                ({result.newUsers > 0 ? "+" : ""}
                {Math.floor(result?.newUsers)}€)
              </Text>
            </Text>
          </Group>
          <Badge
            leftSection={
              result.rate < 0 ? (
                <IconArrowDown size={16} />
              ) : (
                <IconArrowUp size={16} />
              )
            }
            size="lg"
            variant="light"
            color={result.rate < 0 ? "red.6" : "green.8"}
            ml={"auto"}
          >
            {result.rate}%
          </Badge>
        </Paper>
      </HoverCard.Target>

      <HoverCard.Dropdown>
        <Stack>
          <Text size="lg">
            <b>
              <NumberFormatter
                value={Math.floor(stats.stats_current_range?.total_sum_billed)}
              />
              €
            </b>{" "}
            sur cette période
          </Text>
          <Text size="lg">
            <b>
              <NumberFormatter
                value={Math.floor(stats.stats_previous_range?.total_sum_billed)}
              />
              €
            </b>{" "}
            sur la période d'avant
          </Text>
        </Stack>
      </HoverCard.Dropdown>
    </HoverCard>
  );
};
export default TotalBilling;
